import React from 'react';
import { motion } from 'framer-motion';
interface MiniDonutChartProps {
  percentage: number;
}
export const MiniDonutChart: React.FC<MiniDonutChartProps> = ({
  percentage
}) => {
  const radius = 24;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - percentage / 100);
  return <div className="relative inline-flex items-center justify-center w-16 h-16" data-id="element-327">
      <svg className="w-full h-full transform -rotate-90" data-id="element-328">
        <circle cx="32" cy="32" r={radius} stroke="#E5E7EB" strokeWidth="4" fill="none" data-id="element-329" />
        <motion.circle cx="32" cy="32" r={radius} stroke="#C00000" strokeWidth="4" fill="none" initial={{
        strokeDasharray: circumference,
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-330" />
      </svg>
      <span className="absolute text-sm font-medium text-[#101010]" data-id="element-331">
        {percentage.toFixed(1)}%
      </span>
    </div>;
};